// tslint:disable
export var CoveragedetCoverageStatus;
(function (CoveragedetCoverageStatus) {
    // Other/Unknown/Error determining the coverage status. See Coverage Status Text for details
    CoveragedetCoverageStatus[CoveragedetCoverageStatus["Unknown"] = 0] = "Unknown";
    // CoveredWithRestrictions
    CoveragedetCoverageStatus[CoveragedetCoverageStatus["CoveredWithRestrictions"] = 1] = "CoveredWithRestrictions";
    // Covered
    CoveragedetCoverageStatus[CoveragedetCoverageStatus["Covered"] = 2] = "Covered";
    // ErrorProcessingPharmacyType
    CoveragedetCoverageStatus[CoveragedetCoverageStatus["ErrorProcessingPharmacyType"] = 3] = "ErrorProcessingPharmacyType";
    // NotCovered
    CoveragedetCoverageStatus[CoveragedetCoverageStatus["NotCovered"] = 4] = "NotCovered";
})(CoveragedetCoverageStatus || (CoveragedetCoverageStatus = {}));
CoveragedetCoverageStatus['UNKNOWN'] = 0;
CoveragedetCoverageStatus['COVEREDWITHRESTRICTIONS'] = 1;
CoveragedetCoverageStatus['COVERED'] = 2;
CoveragedetCoverageStatus['ERRORPROCESSINGPHARMACYTYPE'] = 3;
CoveragedetCoverageStatus['NOTCOVERED'] = 4;
//# sourceMappingURL=CoveragedetCoverageStatus.js.map